import { Pipe, PipeTransform } from '@angular/core';

import { itemTipoSituacoes } from '../item-tipo-situacao';

@Pipe({
    name: 'itemTipoSituacao'
})
export class ItemTipoSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = itemTipoSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return itemTipoSituacoes[index].nome;
        }
        return '';
    }
}
